import styled from 'styled-components';

import { Dialog as DefaultDialog } from '@xing-com/dialog';

export const Dialog = styled(DefaultDialog)`
  text-align: center;
`;
